import { FC, useState } from 'react';
import { useOutsideClickClose } from 'shared/lib/datepicker';
import { DatePickerInput } from 'shared/ui/datepicker';
import { useResize } from 'app/lib/hooks/useResize';

interface DatePickerProps {
	value: Date;
	onChange: (date: Date) => void;
}

export const DatePicker: FC<DatePickerProps> = ({ onChange, value }) => {
	const [isOpenCalendar, setOpenCalendar] = useState<boolean>(false);

	const toggleCalendar = () => setOpenCalendar(prev => !prev);
	const closeCalendar = () => setOpenCalendar(false);

	const nextDay = () => {
		const newDate = new Date(value);
		newDate.setDate(value.getDate() + 1);

		onChange(newDate);
	};

	const prevDay = () => {
		const newDate = new Date(value);
		newDate.setDate(value.getDate() - 1);

		onChange(newDate);
	};

	const onSelect = (date: Date) => {
		onChange(date);
		closeCalendar();
	}

	const onMonthChange = (date: Date) => {
		onChange(date);
	}

	useOutsideClickClose(closeCalendar, 'main-calendar');

  const { 
    isScreenSm
  } = useResize();

	return (
		<DatePickerInput
			leftControlClick={prevDay}
			rightControlClick={nextDay}
			dateTextClick={toggleCalendar}
			onSelect={onSelect}
			onMonthChange={onMonthChange}
			isOpenCalendar={isOpenCalendar}
			selected={value}
			id="main-calendar"
      isScreenSm={isScreenSm}
		/>
	);
};
